import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import HeadlineMobile from 'hb-builder/components/BuilderComponents/single/Headline/HeadlineSettings/HeadlineMobile';
import { useDeviceModeContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { HeadlineItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/headlineItemAttributes';

import Container from './Container';
import Headline from './Headline';

const HeadlineSettings = (
  props: ComponentSettingsTab<HeadlineItemAttributes>,
) => {
  const { isMobileMode } = useDeviceModeContext();
  const { item } = props;

  const settingProps = {
    ...props,
    item: {
      ...item,
      attributes: {
        // Force type because generic type attributes can be undefined which is not the case here
        ...(item.attributes as HeadlineItemAttributes),
        textFontSize: (item.attributes as HeadlineItemAttributes)
          .headlineFontSize[isMobileMode ? 's' : 'xl'],
        textLineHeight: (item.attributes as HeadlineItemAttributes)
          .headlineLineHeight[isMobileMode ? 's' : 'xl'],
      },
    },
  };

  return (
    <Wrapper dataTestId="headlineSettings">
      {isMobileMode ? (
        <HeadlineMobile {...settingProps} />
      ) : (
        <>
          <Headline {...settingProps} />
          <Container {...settingProps} />
        </>
      )}
    </Wrapper>
  );
};

export default HeadlineSettings;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  mt: '10px',
  width: '100%',
}))``;
